// extracted by mini-css-extract-plugin
export default {"root":"old-price-field-module_root-tMfIi"};